import {
  BodyText,
  DatePicker,
  TextInput,
} from "@utilitywarehouse/hearth-react";

import { QuestionsDataTest } from "../constants";

export interface TemporaryNeedsQuestionProps {
  question: string;
  reason: string;
  label: string;
  onChangeDate: (value: Date | null) => void;
  currentDate?: Date | null;
}

const TemporaryNeedsQuestion: React.FC<TemporaryNeedsQuestionProps> = ({
  question,
  reason,
  label,
  onChangeDate,
  currentDate,
}) => {
  const today = new Date();
  const nineMonthsFromNow = new Date();
  nineMonthsFromNow.setMonth(today.getMonth() + 9);

  return (
    <div>
      <BodyText data-testid={QuestionsDataTest.TEMPORARY_NEEDS_QUESTION}>
        {question}
      </BodyText>

      <BodyText data-testid={QuestionsDataTest.TEMPORARY_NEEDS_REASON}>
        {reason} <b>'{label}'</b>
      </BodyText>

      <DatePicker
        label=""
        selected={currentDate}
        onChange={onChangeDate}
        required
        customInput={
          <TextInput
            label=""
            data-testId={QuestionsDataTest.TEMPORARY_NEEDS_DATE_PICKER}
          />
        }
        maxDate={
          question === "When is your due date?" ? nineMonthsFromNow : today
        }
      />
    </div>
  );
};

export default TemporaryNeedsQuestion;
